import React from 'react';
import { motion } from 'framer-motion';
import './Reviews.css';

const Reviews = () => {
  const getInitials = (name) => {
    return name.split(' ').map(n => n[0]).join('').toUpperCase();
  };

  const getAvatarColor = (index) => {
    const colors = ['#FF6B6B', '#4ECDC4', '#667EEA', '#764BA2', '#F15A24', '#FFA500'];
    return colors[index % colors.length];
  };

  const reviews = [
    {
      id: 1,
      name: 'Priya Sharma',
      company: 'Tech Solutions Inc.',
      role: 'CEO',
      rating: 5,
      text: 'Suraj\'s expertise in web development transformed our business. The solutions provided were innovative, scalable, and exceeded our expectations. Highly recommended!'
    },
    {
      id: 2,
      name: 'Amit Patel',
      company: 'Digital Innovations Ltd.',
      role: 'Project Manager',
      rating: 5,
      text: 'Working with Suraj was a fantastic experience. His technical knowledge and problem-solving skills are unparalleled. He delivered the project on time with exceptional quality.'
    },
    {
      id: 3,
      name: 'Sarah Johnson',
      company: 'Global Tech Ventures',
      role: 'Business Development Manager',
      rating: 5,
      text: 'As a consultant, Suraj provided valuable insights that helped us streamline our tech infrastructure. His recommendations were practical and highly beneficial for our organization.'
    },
    {
      id: 4,
      name: 'Rajesh Kumar',
      company: 'StartUp Hub',
      role: 'Founder',
      rating: 5,
      text: 'Suraj\'s entrepreneurial mindset and technical acumen make him a perfect partner for tech ventures. His involvement in Solutionspath Tech has been instrumental in its success.'
    },
    {
      id: 5,
      name: 'Emma Williams',
      company: 'Mobile Apps Co.',
      role: 'CTO',
      rating: 5,
      text: 'Outstanding Flutter developer! Suraj delivered a beautiful and functional mobile app that our users love. His attention to detail is remarkable.'
    },
    {
      id: 6,
      name: 'Vikram Singh',
      company: 'Enterprise Systems Ltd.',
      role: 'Director',
      rating: 5,
      text: 'I\'ve collaborated with Suraj on multiple projects. His commitment to excellence and innovative approach to problem-solving make him an invaluable asset to any team.'
    }
  ];

  return (
    <motion.div
      className="reviews"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <div className="container">
        <motion.div
          className="reviews-header"
          initial={{ y: -30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          <h2>Client Reviews & Testimonials</h2>
          <p>What clients say about working with me</p>
        </motion.div>

        <div className="reviews-grid">
          {reviews.map((review, index) => (
            <motion.div
              key={review.id}
              className="review-card"
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: index * 0.1, duration: 0.6 }}
              whileHover={{ y: -5 }}
            >
              <div className="review-header">
                <div className="reviewer-info">
                  <div className="reviewer-avatar" style={{ backgroundColor: getAvatarColor(index) }}>{getInitials(review.name)}</div>
                  <div className="reviewer-details">
                    <h3>{review.name}</h3>
                    <p className="role">{review.role}</p>
                    <p className="company">{review.company}</p>
                  </div>
                </div>
                <div className="review-rating">
                  {[...Array(review.rating)].map((_, i) => (
                    <span key={i} className="star">⭐</span>
                  ))}
                </div>
              </div>
              <p className="review-text">"{review.text}"</p>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default Reviews;